import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Divider,
  Paper
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getIcon } from '../../../utils/IconHandler';

const ViewEmailModal = ({ open, onClose, email }) => {
  const { t } = useTranslation();

  if (!email) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Typography variant="h6" gutterBottom>
            {t('email_preview')}
          </Typography>
          <Paper sx={{ p: 2, minHeight: 400, border: '1px solid', borderColor: 'divider', mt: 2 }}>
            <Typography variant="h6" gutterBottom>
              {email.subject || t('email_preview')}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Box
              dangerouslySetInnerHTML={{ __html: email.htmlContent || t('no_content') }}
              sx={{
                '& img': { maxWidth: '100%' },
                '& a': { color: 'primary.main' }
              }}
            />
          </Paper>
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewEmailModal;

